module.exports = "/_next/static/images/wallet-line-3a1bc42b1bb9bb3f1c0887c10206de10.svg";